// Dependenceis
import React, { PropTypes } from 'react';
import getClassNames from 'classnames';
import ConnectionsTagsContainer from './connections-tags-modal/connections-tags-container';
import ConnectionsTag from './connections-tag';
import { Dialog, FontIcon } from 'material-ui';
import ProfileImage from '../app-bar/profile-image';
import VertDropDown from './connections-vert-dropdown';
import languagesObj from '../../localization/languages.json';
const languageSettings = languagesObj['en-US'];
import { RaisedButton } from 'material-ui';
import ActivityIcon from 'material-ui/svg-icons/action/swap-horiz';
import { connect } from 'react-redux';
import moment from 'moment';
import { addConnectionAsPartner } from './__storeFiles__/actions';

const propTypes = {
  companyId: PropTypes.string,
  id: PropTypes.string,
  isEmailContact: PropTypes.bool,
  email: PropTypes.string,
  connectionOrigin: PropTypes.string,
  status: PropTypes.string,
  lastSent: PropTypes.string,
  profileImageUrl: PropTypes.string,
  history: PropTypes.object,
  className: PropTypes.string,
  name: PropTypes.string,
  allUserTags: PropTypes.array,
  tags: PropTypes.array,
  resendConnection: PropTypes.func,
  acceptConnection: PropTypes.func,
  ignoreConnection: PropTypes.func,
  removeConnection: PropTypes.func,
  addOrRemoveTag: PropTypes.func,
  partner: PropTypes.object,
  connectionId: PropTypes.string,
  addConnectionAsPartner: PropTypes.func,
};

class ListItem extends React.Component {
  constructor() {
    super();
    this.state = {
      typeAheadOpen: false,
      menuDropDownOpen: false,
      dialogOpen: false,
    };
  }

  transitionToProfile = () => {
    const { companyId, history } = this.props;
    if (companyId) history.push(`/company/${companyId}`);
  };

  toggleTypeAhead = () => {
    this.showDialog();
  };

  toggleZIndex = () => {
    this.setState({ menuDropDownOpen: !this.state.menuDropDownOpen });
  };

  dismissDialog = () => {
    this.setState({ dialogOpen: false });
  };

  showDialog = () => {
    this.setState({ dialogOpen: true });
  };

  render() {
    const classes = getClassNames('connections-company-name', this.props.className, {
      'is-link': this.props.companyId,
    });

    const listItemClasses = getClassNames('connections-list-item', {
      'is-open': this.state.menuDropDownOpen,
    });

    const modal = (
      <Dialog
        className="form-dialog tags-modal"
        title={`Tags for ${this.props.name}`}
        ref="tagsModal"
        open={this.state.dialogOpen}
        onRequestClose={this.dismissDialog}
      >
        <ConnectionsTagsContainer {...this.props} isTagModal allUserTags={this.props.allUserTags} />
      </Dialog>
    );

    let email;
    let header;
    let dropDownButton;
    const category = (() => {
      if (this.props.status === 'accepted') return 'connected';
      if (this.props.status === 'pending') {
        if (this.props.lastSent) {
          if (this.props.isEmailContact) return 'connected';
          return 'invites';
        }
        return 'requests';
      }
    })();
    const options = [
      {
        text: (
          <span>
            <FontIcon
              className="tc-icon-remove_red_eye"
              style={{ color: '#00bcd4', fontSize: '14px', marginRight: '5px' }}
            />
            View Profile
          </span>
        ),
        action: this.transitionToProfile,
      },
    ];
    switch (category) {
      case 'invites':
        // TODO: if other user has rejected request, do not show drop down button
        options.push({
          text: (
            <span>
              <FontIcon
                className="tc-icon-near_me"
                style={{ color: '#00bcd4', fontSize: '14px', marginRight: '5px' }}
              />
              Resend Partner Request
            </span>
          ),
          action: this.props.resendConnection,
        });
        options.push({
          text: (
            <span>
              <FontIcon
                className="tc-icon-delete2"
                style={{ color: 'rgb(255, 64, 129)', fontSize: '14px', marginRight: '5px' }}
              />
              Cancel Partner Request
            </span>
          ),
          action: this.props.removeConnection,
        });
        dropDownButton = (
          <VertDropDown
            componentClassName="connections-actions"
            toggleZIndex={this.toggleZIndex}
            options={options}
            style={{ lineHeight: '24px' }}
            payload={this.props.id}
          />
        );
        break;
      case 'requests':
        dropDownButton = (
          <VertDropDown
            componentClassName="connections-actions"
            toggleZIndex={this.toggleZIndex}
            options={options}
            style={{ lineHeight: '24px' }}
            isRequest
            acceptConnection={this.props.acceptConnection}
            ignoreConnection={this.props.ignoreConnection}
            payload={this.props.id}
          />
        );
        break;
      case 'connected':
      default:
        options.unshift({
          text: (
            <span>
              <FontIcon
                className="tc-icon-message"
                style={{ color: 'rgb(0, 188, 212)', fontSize: '14px', marginRight: '5px' }}
              />
              Send a Message
            </span>
          ),
          action: () => {
            this.context.router.push(`/workspace/${this.props.companyId || this.props.email}`);
          },
        });
        options.push({
          text: (
            <span>
              <FontIcon
                className="tc-icon-delete2"
                style={{ color: 'rgb(255, 64, 129)', fontSize: '14px', marginRight: '5px' }}
              />
              {languageSettings.connections.listItem.removeConnection}
            </span>
          ),
          action: this.props.removeConnection,
        });
        dropDownButton = (
          <VertDropDown
            componentClassName="connections-actions"
            style={{ lineHeight: '24px' }}
            toggleZIndex={this.toggleZIndex}
            payload={this.props.id}
            options={options}
          />
        );
        break;
    }

    if (this.props.email && (category === 'requests' || category === 'connected')) {
      email = <div className="connections-list-email">{this.props.email}</div>;
    }

    if (this.props.name) {
      header = (
        <div>
          <div className="connections-list-header" onClick={this.transitionToProfile}>
            {this.props.name}
          </div>
          <i>{moment(this.props.created_at).fromNow()}</i>
        </div>
      );
    }

    const tags = Array.isArray(this.props.tags) ? this.props.tags : [];

    const companyTags = tags.map((tag, index) => (
      <ConnectionsTag
        key={index}
        className="individual-company-tag"
        tag={tag}
        addOrRemoveTag={this.props.addOrRemoveTag}
      />
    ));

    const tagsToDisplay = <div className="company-tags-container">{companyTags}</div>;

    let companyDisplay;

    if (header) {
      companyDisplay = (
        <div className={classes}>
          <div className="inner-tags-container">
            {header}
            {tagsToDisplay}
          </div>
          {email}
        </div>
      );
    } else {
      companyDisplay = (
        <div className={classes}>
          {email}
          {tagsToDisplay}
        </div>
      );
    }

    return (
      <div className={listItemClasses} style={{ borderBottom: '1px solid #f0f0f0' }}>
        <div className="connections-profile-image-container">
          <ProfileImage
            className="profile-link-image connections-profile-link-image"
            companySlugName={this.props.name}
            email={this.props.email}
            imageUrl={this.props.profileImageUrl}
          />
        </div>
        <div
          className="connections-company-container"
          style={{
            minHeight: '72px',
            padding: '8px 0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          {companyDisplay}
          {(() => {
            if (category === 'connected') {
              if (this.props.partner && this.props.partner.partnerId) {
                return (
                  <RaisedButton
                    label="View Details"
                    secondary
                    icon={<ActivityIcon />}
                    buttonStyle={{ zIndex: 'inherited' }}
                    onTouchTap={() => {
                      window.location = `${
                        process.env.NEW_SYSTEM_URL
                      }/partner-management/partner-details/${
                        this.props.partner.partnerId
                      }?jwt=${localStorage.getItem('jwt')}`;
                    }}
                  />
                );
              }
              return (
                <RaisedButton
                  label="Add as Partner"
                  primary
                  buttonStyle={{ zIndex: 'inherited' }}
                  onTouchTap={() =>
                    this.props.addConnectionAsPartner(this.props.connectionId, this.props.companyId)
                  }
                />
              );
            }
          })()}
          {dropDownButton}
        </div>
        {modal}
      </div>
    );
  }
}
ListItem.contextTypes = {
  router: React.PropTypes.object.isRequired,
};
ListItem.propTypes = propTypes;
export default connect(null, { addConnectionAsPartner })(ListItem);



// WEBPACK FOOTER //
// ./src/app/components/connections/connections-list-item.jsx